import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import { Col, Row } from 'react-bootstrap';
import {
  Card, CardBody,
} from '@/shared/components/Card';
import Select, { components } from 'react-select';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
  FormHalfContainer,
 
} from '@/shared/components/form/FormElements';
import { renderMaskedField } from '@/shared/components/form/FormField';
import { Button } from '@/shared/components/Button';
import { GlobalContext } from '../../../../context/GlobalContext';

const EditAgentData = ({ agentData, onSubmit }) => {
   console.log('agentData', agentData);
    const { apiGlobal } = useContext(GlobalContext);
  const path = `${apiGlobal}/images/agent/`;
  const gstpath = `${apiGlobal}/images/agent/GST/`;
  const [selectedImage, setSelectedImage] = useState(path + agentData.logo);
  const [selectedAdressProof, setSelectedAdressProof] = useState(gstpath + agentData.addressProof);
  const [selectedGstProof, setSelectedGSTProof] = useState(gstpath + agentData.gstProof);
  const [country, setCountry] = useState([]);
  const [countryCodeSelect, setcountryCodeSelect] = useState({
    value: agentData.countryCodeId,
    label: agentData.countryCode,
  });
  const [countrySelect, setCountrySelect] = useState({
    value: agentData.country,
    label: agentData.countryName,
  });

  const handleFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result); 
      };
      reader.readAsDataURL(file);
      input.onChange(file); 
    } else {
      setSelectedImage(null); 
      input.onChange(null); 
    }
  };

  const handAddressFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedAdressProof(reader.result);
      };
      reader.readAsDataURL(file);
      input.onChange(file);
    } else {
      setSelectedAdressProof(null);
      input.onChange(null);
    }
  };


  const handGstFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedGSTProof(reader.result);
      };
      reader.readAsDataURL(file);
      input.onChange(file);
    } else {
      setSelectedGSTProof(null);
      input.onChange(null);
    }
  };


  const fetchCountryList = async () => {
      try {
        const url = await fetch(`${apiGlobal}/currency_master_list.php`, {
          method: 'POST',
        });
        const response = await url.json();
        if (response.status && response.message === 'Success') {
          setCountry(response?.data);
        } else {
          setCountry([]);
        }
      } catch (error) {
        console.log(error);
      } 
    };
  
    useEffect(() => {
      fetchCountryList();
    }, []);

  return (
    <Col md={12} lg={12}>
     
      <Form onSubmit={onSubmit} initialValues={agentData}>
        {({ handleSubmit }) => (
          <FormContainer onSubmit={handleSubmit}>
            <Card>
              <CardBody>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Agent Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="agentName"
                          component="input"
                          type="text"
                          placeholder="Agent Name"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Email Address<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="userEmail"
                          component="input"
                          type="text"
                          placeholder="Email/Username"
                          required
                          style={{ height: '45px' }}
                          validate={value => (value ? undefined : 'Required')}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    
                    <FormGroup>
                      <FormGroupLabel>
                        Phone Number<span style={{ color: 'red' }}>*</span>
                      </FormGroupLabel>
                      <FormGroupField>
                        <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                          {/* Country Code Select */}
                          <Field
                            name="countryCodeId"
                            render={({ input, meta }) => (
                              <div>
                                <Select
                                  {...input}
                                  options={country.map(item => ({
                                  value: item.id,
                                  label: item.country_code,
                                }))}
                                  value={countryCodeSelect}
                                  onChange={(selectedOption) => {
                                  setcountryCodeSelect(selectedOption);
                                  input.onChange(selectedOption.value);
                                }}
                                  placeholder="Code"
                                  classNamePrefix="react-select"
                                  components={{
                                  DropdownIndicator: () => null,
                                  IndicatorSeparator: () => null,
                                }}
                                  styles={{
                                  control: provided => ({
                                    ...provided,
                                    width: '70px',
                                    height: '45px',
                                    borderRadius: '5px',
                                  }),
                                  menu: provided => ({
                                    ...provided,
                                    width: '70px',
                                    zIndex: 9999,
                                  }),
                                  option: provided => ({
                                    ...provided,
                                    width: '70px',
                                  }),
                                }}
                                />
                                {meta.touched && meta.error && (
                                  <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                  )}
                              </div>
                            )}
                          />

                          {/* Phone Input */}
                          <Field
                            name="userPhone"
                            render={({ input, meta }) => (
                              <div style={{ flex: 1 }}>
                                <input
                                  {...input}
                                  type="text"
                                  inputMode="numeric"
                                  // pattern="\d{12}"
                                  maxLength={12}
                                  placeholder="Enter Phone Number"
                                  style={{
                                  width: '100%',
                                  height: '45px',
                                  padding: '10px',
                                  borderRadius: '5px',
                                  border: '1px solid gray',
                                }}
                                  onInput={(e) => {
                                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                  input.onChange(e.target.value);
                                }}
                                />
                                {meta.touched && meta.error && (
                                  <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                              )}
                              </div>
                            )}
                          />
                        </div>
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>UAN<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="uan"
                          component="input"
                          type="number"
                          placeholder="UAN"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Address Line 1<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="addressline1"
                          component="input"
                          type="text"
                          placeholder="Address Line 1"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Address Line 2</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="addressline2"
                          component="input"
                          type="text"
                          placeholder="Address Line 2"
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Area<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="area"
                          component="input"
                          type="text"
                          placeholder="Area"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="city"
                          component="input"
                          type="text"
                          placeholder="City"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>State<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="state"
                          component="input"
                          type="text"
                          placeholder="State"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Pincode<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="pincode"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          maxLength={6} 
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6);
                          }}
                          placeholder="Pincode"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Select Country<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="country"
                          render={({ input, meta }) => (
                            <Select
                              {...input} 
                              name="country"
                              style={{ height: '40px' }}
                              options={country.map(item => ({
                                value: item.id,
                                label: item.country_name,
                              }))}
                              value={countrySelect}
                              onChange={(selectedOption) => {
                                setCountrySelect(selectedOption);
                                input.onChange(selectedOption.value);
                              }}
                              className="react-select w-100"
                              classNamePrefix="react-select"
                              placeholder="Select a Country"
                              styles={{
                                width: '100%',
                            control: provided => ({
                              ...provided,
                             
                            }),
                            singleValue: provided => ({
                              ...provided,
                              
                            }),
                          }}
                            />
                      )}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Location<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="location"
                          component="input"
                          type="text"
                          placeholder="Location"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Logo</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="file"
                          render={({ input }) => (
                            <input
                              type="file"
                              onChange={e => handleFileChange(e, input)}
                              style={{ height: '45px' }}
                            />
                        )}
                        />
                      </FormGroupField>
                    </FormGroup>
                    {selectedImage && (
                    <FormGroup>
                      <FormGroupLabel>Selected Logo</FormGroupLabel>
                      <FormGroupField>
                        <img
                          src={selectedImage}
                          alt="Selected Logo"
                          style={{ maxWidth: '200px', maxHeight: '200px', height: '150px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  )}
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Address Proof</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="addressProof"
                          render={({ input }) => (
                            <input
                              type="file"
                              onChange={e => handAddressFileChange(e, input)}
                              style={{ height: '45px' }}
                            />
                        )}
                        />
                      </FormGroupField>
                    </FormGroup>
                    {selectedAdressProof !== gstpath
                  ? (
                    <FormGroup>
                      <FormGroupLabel>Selected Address Proof</FormGroupLabel>
                      <FormGroupField>
                        <img
                          src={selectedAdressProof}
                          alt="Selected Address Proof"
                          style={{ maxWidth: '200px', maxHeight: '200px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  ) : (
                    <div>
                      <span style={{ color: 'red' }}>
                        No Prior Address Proof Upload
                      </span>
                    </div>
                  )}
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>GST Proof</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="gstProof"
                          render={({ input }) => (
                            <input
                              type="file"
                              onChange={e => handGstFileChange(e, input)}
                              style={{ height: '45px' }}
                            />
                        )}
                        />
                      </FormGroupField>
                    </FormGroup>
                    {selectedGstProof !== gstpath ? (
                      <FormGroup>
                        <FormGroupLabel>Selected GST Proof</FormGroupLabel>
                        <FormGroupField>
                          <img
                            src={selectedGstProof}
                            alt="Selected Address Proof"
                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                          />
                        </FormGroupField>
                      </FormGroup>
                  ) : (
                    <div>
                      <span style={{ color: 'red' }}>
                        No Prior Gst Proof Upload
                      </span>
                    </div>
                  ) }
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>GST No</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="gstNo"
                          component="input"
                          type="text"
                          maxLength={15}
                          placeholder="GST No"
                          parse={value => value?.toUpperCase()} // Auto-uppercase
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>GST Type</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="gstType"
                          component="input"
                          type="text"
                          placeholder="GST Type"
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Default Markup<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="defaultMarkup"
                          component="input"
                          type="number"
                          placeholder="Default Markup"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>TAX Identification<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="taxId"
                          component="input"
                          type="text"
                          placeholder="Tax Identification"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>TAX City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="taxCity"
                          component="input"
                          type="text"
                          placeholder="Tax City"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <FormButtonToolbar>
                  <Button variant="primary" type="submit">Submit</Button>
                </FormButtonToolbar>
              </CardBody>
            </Card>
          </FormContainer>
            )}
      </Form>
      
    </Col>
  );
}; 

EditAgentData.propTypes = {
    agentData: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    agentName: PropTypes.string,
    addressline1: PropTypes.string,
    addressline2: PropTypes.string,
    area: PropTypes.string,
    city: PropTypes.string,
    pincode: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
    location: PropTypes.string,
    uan: PropTypes.string,
    taxId: PropTypes.string,
    taxCity: PropTypes.string,
    addressProof: PropTypes.string,
    gstProof: PropTypes.string,
    gstNo: PropTypes.string,
    gstType: PropTypes.string,
    defaultMarkup: PropTypes.string,
    logo: PropTypes.string,
    userEmail: PropTypes.string,
    userPhone: PropTypes.string,
    countryName: PropTypes.string,
    countryCode: PropTypes.string,
    countryCodeId: PropTypes.string,
    
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default EditAgentData;
